<template>
  <div class="logo-bg primary-bg pb-1 mb-0 min-h-screen flex width-full flex-col">
    <nav class="flex items-center justify-between flex-wrap primary-bg p-2">
      <div class="flex items-center flex-no-shrink text-white mr-6">
        <router-link :to="{name:'home'}">
          <img
            src="static/sp_g.svg"
            height="32"
            width="32"
          >
        </router-link>
      </div>
      <div class="block md:hidden">
        <button
          class="flex items-center px-3 py-2 border rounded text-teal-lighter border-teal-light hover:text-white hover:border-white"
        >
          <svg
            class="fill-current h-3 w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          ><title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div class="w-full block flex-grow md:flex items-center md:w-auto">
        <div class="flex text-white text-center md:flex-grow  items-center">
          <sc-nav-bread class="h-2 mt-2" />
        </div>

        <div>
          <router-link
            :to="{name:'me'}"
            class="inline-block text-sm mr-4 px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal hover:bg-white mt-4 lg:mt-0"
          >
            <div v-if="me && me.displayName">
              {{ me.displayName }}
            </div>
            <div v-else>
              Profil
            </div>
          </router-link>
        </div>
        <div>
          <a
            href="#"
            class="inline-block text-sm mr-4 px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal hover:bg-white mt-4 lg:mt-0"
            onclick="cookiefirst_show_settings();"
          >Cookies</a>
        </div>

        <div>
          <a
            href="#"
            class="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal hover:bg-white mt-4 lg:mt-0"
            @click="logout"
          >Logout</a>
        </div>
      </div>
    </nav>

    <div class="mt-0 min-h-full align-top">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>
<script>
import authService from '../auth/authService'
import apiService from './api/apiService'
import { bus } from '../main'
import { userClient } from '@/components/api/clients.context'

export default {
    name: 'Layout',
    data () {
        return {
            selectedTeam: '',
            teams: [],
            authenticated: false,
            user: authService.user,
            searchAllTerm: '',
            searchAllResults: [],
            me: null
        }
    },
    computed: {
        displayTeam: function () {
            return this.selectedTeam
        },
        displayTeams: function () {
            return this.teams
        }
    },

    created () {
        bus.$on('user.changed', (user) => {
            this.loadTeams()
        })
    },

    async mounted () {
      this.me = await userClient.getMe()

      this.authenticated = await authService.isAuthenticated()
        await this.loadTeams()
    },

  async activated () {
    this.me = await userClient.getMe()

    if (this.$route.name !== 'me' && (!this.me || !this.me.displayName)) {
      await this.$router.push({ name: 'me' })
    }
  },

    methods: {
        async loadTeams () {
            var teams = await apiService.getMyTeams()

            if (teams && teams.status === 200) {
                this.teams = teams.data

                if (this.teams) {
                    var storedTeam = localStorage.getItem('currentTeam')

                    if (storedTeam) {
                        this.selectedTeam = storedTeam
                    } else if (this.teams.length === 1) {
                        this.selectedTeam = this.teams[0].teamId
                        localStorage.setItem('currentTeam', this.selectedTeam)
                    }
                }
            }
        },
        async searchAll () {
            const response = await apiService.searchAll(this.searchAllTerm)
            this.searchAllResults = response.data.items
        },
        teamSelected () {
            if (this.selectedTeam && this.selectedTeam === 'create') {
                this.selectedTeam = ''
                this.$router.push({ name: 'teams.create' })
            } else {
                localStorage.setItem('currentTeam', this.selectedTeam)
            }
            console.log('team ' + this.selectedTeam)
        },
        login () {
            localStorage.setItem('loginRedirect', this.$route.fullPath)
            authService.login()
        },

        async logout () {
            await authService.logout()
        }
    }
}
</script>

<style lang="scss">

  ol {
    line-height: 0.9;
  }

  ul {
    line-height: 0.9;
  }

  div a {
    color: inherit;
    text-underline: none;
    text-decoration: none;
  }

  .appBack {

  }

</style>
